import React, { useEffect, useRef, useState } from 'react';
import styles from './CountryAddEdit.module.scss';
import { Box, Button, Card, CardContent, Chip, CircularProgress, IconButton, Link, Typography } from '@mui/material';
import { Close, Delete } from '@mui/icons-material';
import { useFieldArray, useForm } from 'react-hook-form';
import InputCustom from '../InputCustom/InputCustom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { uploadFile } from '../../../redux/actions/app/uploadFile';
import PrevImage from '../PrevImage/PrevImage';
import Loading from '../Loading/Loading';
import { resetDeleteItem, resetCountryCreate, resetCountryEdit, resetUploadFile } from '../../../redux/slices/app.slice';
import { countryCreate } from '../../../redux/actions/app/countryCreate';
import InfoAlert from '../InfoAlert/InfoAlert';
import { leagueList } from '../../../redux/actions/app/leagueList';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { deleteItem } from '../../../redux/actions/app/deleteItem';
import DeleteBtn from '../DeleteBtn/DeleteBtn';
import MaskEdit from '../MaskEdit/MaskEdit';
import { countryEdit } from '../../../redux/actions/app/countryEdit';
import { countryList } from '../../../redux/actions/app/countryList';
const CountryAddEdit = ({ league, type, onClose }) => {
  const form = useForm();
  const [showAlert, setShowAlert] = useState(false);

  const {
    countryCreate: { data: countryCreateData, loading: countryCreateLoading },
    countryEdit: { data: countryEditData, loading: countryEditLoading },
    deleteItem: { data: deleteItemData, loading: deleteItemLoading },
  } = useSelector((state) => state.app);
  const {
    uploadFile: { data: uploadFileData, loading: uploadFileLoading },
  } = useSelector((state) => state.app);
  useEffect(() => {
    if (deleteItemData) {
      toast.success('Лига удалена');
      onClose();
      dispatch(leagueList());

      dispatch(resetDeleteItem());
    }
  }, [deleteItemData]);

  useEffect(() => {
    if (league && type == 'edit') {
      form.setValue('name', league.name);
      form.setValue('image', league.logo);
      form.setValue('code', league.code);
      form.setValue('mask', league.mask);
    }
  }, [league]);

  useEffect(() => {
    if (countryCreateData) {
      toast.success('Страна создана');
      onClose();

      dispatch(resetCountryCreate());
    }
  }, [countryCreateData]);
  useEffect(() => {
    if (countryEditData) {
      toast.success('Страна отредактирована');
      onClose();

      dispatch(resetCountryEdit());
    }
  }, [countryEditData]);
  useEffect(() => {
    if (uploadFileData) {
      form.clearErrors('image');
      form.setValue('image', uploadFileData?.url);
      dispatch(resetUploadFile());
    }
  }, [uploadFileData]);
  useEffect(() => {
    form.register('image', { required: true });
  }, []);
  const imageError = form.formState.errors?.image;
  const [userList, setUserList] = useState([]);

  const getTitle = () => {
    switch (type) {
      case 'create':
        return 'Создание страны';
      case 'edit':
        return 'Редактирование страны';
        break;

      default:
        break;
    }
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const refFile = useRef();
  const onSubmit = (data) => {
    const { name, image, code, mask } = data;

    if (type == 'edit') {
      dispatch(countryEdit({ code: typeof data.code !== 'number' ? parseInt(data.code.replace(/\D/g, '')) : data.code, mask, name, logo: image, countryId: league?.id }));
    } else {
      dispatch(countryCreate({ code: typeof data.code !== 'number' ? parseInt(data.code.replace(/\D/g, '')) : data.code, mask, name, logo: image }));
    }
  };

  return (
    <Card
      sx={{
        boxShadow: 3,
        '&.MuiPaper-root': {
          overflow: 'visible',
        },
      }}>
      <Box sx={{ padding: '16px 16px 24px 16px' }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '600' }}>
            {getTitle()}
          </Typography>
          <IconButton sx={{ padding: 0 }} onClick={onClose}>
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ position: 'relative', mb: 2, alignItems: 'start', display: 'flex', flexDirection: 'column', maxWidth: '120px', gap: 0.5 }}>
          <PrevImage form={form} name={'image'} label={'Флаг'} radius={'50%'} />
          <Button
            disabled={uploadFileLoading}
            sx={{ width: '100%' }}
            onClick={() => {
              refFile.current.click();
            }}
            color={imageError ? 'error' : 'primary'}
            size="small"
            variant="outlined">
            Загрузить
          </Button>
          {imageError && <Box sx={{ color: 'error.main', fontSize: '12px' }}>Загрузите логотип</Box>}
          {uploadFileLoading && (
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
              <CircularProgress />
            </Box>
          )}
        </Box>
        <input
          style={{ display: 'none', width: 0, height: 0 }}
          ref={refFile}
          accept="image/*"
          multiple="false"
          type="file"
          onChange={(e) => {
            if (e.target.files[0]) {
              const formData = new FormData();
              formData.append('file', e.target.files[0]);
              dispatch(uploadFile(formData));
            }
          }}
        />
        <InputCustom required={true} form={form} name={'name'} label={'Название'} />
        <Box sx={{ mb: '4px', fontWeight: '600' }}>Формат</Box>

        <MaskEdit form={form} />
        <Box sx={{ mt: 4, display: 'grid', gridTemplateColumns: '1fr', gap: 1 }}>
          <Button sx={{ height: '40px' }} onClick={form.handleSubmit(onSubmit)} size="medium" variant="contained">
            {type?.includes('edit') ? 'Сохранить' : 'Создать'}
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default CountryAddEdit;
